import * as React from 'react'
import { observer } from 'mobx-react'
import { CSSTransition } from 'react-transition-group'
import { CONFIG } from '../../config'
import { breakpointStore } from '../../stores'
import { CheckoutProceedButton, CollectionView } from '../collections'
import { collectionListStore } from '../collections/collection-list/collection-list.store'
import { ProductCard } from '../product'
import { Backdrop, Icon, Button, modalStore } from '../shared'
import { cartStore } from './cart.store'
import { CartUpsell } from './cart-upsell'
import './cart.scss'

const CartComponent = () => {
  const baseClass: string = 'cart'

  const isAboveMd = breakpointStore.breakpoint.above.md

  const iconType = (): string => {
    return isAboveMd ? 'cross' : 'arrow-right-thin'
  }

  const clearCart = (): void => {
    // clear the cart
    cartStore.clearCart()

    // close the modal
    cartStore.toggleShowCart()
    modalStore.toggle()
  }

  const openModal = (): void => {
    const ClearModal = () => (
      <div style={{ textAlign: 'center', padding: '30px' }}>
        <h3>Are you sure you want to clear your cart?</h3>
        <Button gtmId={'cart-clear-confirm'} onClick={() => clearCart()}>
          I'm sure
        </Button>
      </div>
    )

    modalStore.set(<ClearModal />)
    modalStore.toggle()
  }

  const upsellProduct = collectionListStore.products.find((product) => product.handle === cartStore.cartUpsell.product)

  return (
    <Backdrop className='flex items--center justify--center' onClick={cartStore.toggleShowCart} show={cartStore.showCart}>
      <CSSTransition classNames='container-animations' in={cartStore.slideInCart} timeout={CONFIG.animation.timeouts.cartSlideIn}>
        <div className='container flex items--start justify--end full-height'>
          <div className={baseClass}>
            <div className={`${baseClass}__header`}>
              <p>Your order</p>
              <button onClick={cartStore.toggleShowCart}>
                <Icon icon={iconType()} />
              </button>
            </div>
            <div className={`${baseClass}__body`}>
              {cartStore.itemsNormalized.map(({ product }) => (
                <ProductCard key={product.id} view={CollectionView.LIST} {...product} location='cart' />
              ))}
              {upsellProduct && <CartUpsell promotionalText={cartStore.cartUpsell.promotionalText} product={upsellProduct} />}
              {!isAboveMd && <div className={`${baseClass}__body__padding`} />}
            </div>
            <div className={`${baseClass}__footer`}>
              <Button gtmId={'cart-clear'} style='text-medium' iconLeft='trash' onClick={() => openModal()}>
                Clear Cart
              </Button>

              <CheckoutProceedButton
                text={cartStore.hasUnavailableItems ? 'Review order' : 'Checkout'}
                hasUnavailableItems={cartStore.hasUnavailableItems}
                gtmId={'checkout-open'}
                onClick={cartStore.createAjaxCart}
                disabled={cartStore.hasUnavailableItems}
              />
            </div>
            {/* Desktop right-side fill */}
            <div className={`${baseClass}__fill`}>
              <div className={`${baseClass}__header`} />
              <div className={`${baseClass}__footer`} />
            </div>
          </div>
        </div>
      </CSSTransition>
    </Backdrop>
  )
}

export const Cart = observer(CartComponent)
